import {styled} from "@mui/material/styles"

export const Img = styled("img")`
    cursor: pointer;
`
